/** Trigger for skills/prompts context picker in 1:1 chat (group chat uses `@` for people). */
export const CONTEXT_MENTION_TRIGGER = '/';

/** Trigger for picking the agent that answers in 1:1 chat. */
export const AGENT_MENTION_TRIGGER = '@';

/**
 * Remote i18n may still ship "@ for/für/pour/per …". Rewrite that trigger to "/".
 * Leave other "@" alone (email addresses, agent mentions).
 */
export function normalizeContextTriggerHint(text: string): string {
  return text.replace(/(^|(?<=[\s,]))@(?=\s*(?:for|für|Für|FÜR|pour|per)\b)/gi, '/');
}

export function resolveContextTriggerPlaceholder(
  translated: string | undefined,
  translationKey: string,
  fallback: string,
): string {
  const raw = translated?.trim();
  const text = !raw || raw === translationKey ? fallback : raw;
  return normalizeContextTriggerHint(text);
}

export type MentionState = {
  active: boolean;
  query: string;
  startIndex: number;
};

function findMentionTriggerIndex(textBeforeCursor: string, trigger: string): number {
  for (let i = textBeforeCursor.length - 1; i >= 0; i -= 1) {
    if (textBeforeCursor[i] !== trigger) {
      continue;
    }
    const prev = i > 0 ? textBeforeCursor[i - 1] : '';
    if (i === 0 || /\s/.test(prev)) {
      return i;
    }
  }
  return -1;
}

export function getPromptMentionState(
  value: string,
  cursor: number,
  trigger: string = CONTEXT_MENTION_TRIGGER,
): MentionState {
  const textBeforeCursor = value.slice(0, cursor);
  const triggerIndex = findMentionTriggerIndex(textBeforeCursor, trigger);
  if (triggerIndex < 0) {
    return { active: false, query: '', startIndex: -1 };
  }

  const afterTrigger = textBeforeCursor.slice(triggerIndex + 1);
  if (/\s/.test(afterTrigger)) {
    return { active: false, query: '', startIndex: -1 };
  }

  return { active: true, query: afterTrigger, startIndex: triggerIndex };
}
